import React from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '~/components/ui/tooltip';
import { cn } from '~/lib/utils';
import { IconCaretDownFilled } from '@tabler/icons-react';

type EasyTooltipProps = {
  children: React.ReactNode;
  content: React.ReactNode;
  open?: boolean;
  defaultOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
  side?: 'top' | 'right' | 'bottom' | 'left';
  align?: 'start' | 'center' | 'end';
};

export function EasyTooltip({ children, content, open, defaultOpen, onOpenChange, ...props }: EasyTooltipProps) {
  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip open={open} defaultOpen={defaultOpen} onOpenChange={onOpenChange}>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent className="relative overflow-visible" side="top" align="center" {...props}>
          {content}
          <span
            className={cn('text-primary absolute -bottom-[9px] left-0 right-0 m-auto text-center', {
              '-top-[9px] bottom-auto rotate-180': props.side === 'bottom',
              '-right-[14px] bottom-0 left-auto top-0 -rotate-90': props.side === 'left',
              '-left-[14px] bottom-0 right-auto top-0 rotate-90': props.side === 'right',
            })}
          >
            <IconCaretDownFilled className="inline-block" size="16" />
          </span>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
